package com.havn.app.ui.theme

import com.havn.app.features.agency.domain.HavnSubscriptionTier
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.StateFlow
import kotlinx.coroutines.flow.asStateFlow

class HavnThemeManager(
    initialTheme: HavnThemeType = loadStoredHavnThemeType()
) {
    private val _themeType = MutableStateFlow(initialTheme)
    val themeType: StateFlow<HavnThemeType> = _themeType.asStateFlow()

    fun setTheme(type: HavnThemeType, canUsePremiumThemes: Boolean): Boolean {
        val appearanceTheme = type.asAppearanceTheme()
        if (!canUsePremiumThemes && appearanceTheme !in HavnAppearanceThemes) {
            return false
        }
        _themeType.value = appearanceTheme
        storeHavnThemeType(appearanceTheme)
        return true
    }
}

val HavnAppearanceThemes: List<HavnThemeType> = listOf(
    HavnThemeType.OBSIDIAN_GOLD,
    HavnThemeType.LIGHT
)

fun HavnThemeType.asAppearanceTheme(): HavnThemeType =
    if (this == HavnThemeType.LIGHT) HavnThemeType.LIGHT else HavnThemeType.OBSIDIAN_GOLD

fun canUsePremiumThemes(tier: HavnSubscriptionTier): Boolean =
    tier == HavnSubscriptionTier.ProAgent || tier == HavnSubscriptionTier.TeamAgent
